import { SxProps, Theme } from "@mui/material/styles";

export const pageContainer: SxProps<Theme> = {
    display: "flex",
    flexDirection: "column",
    minHeight: "100dvh",
    position: "relative",
    zIndex: 1,
};

export const backButtonContainer: SxProps<Theme> = {
    position: "fixed",
    top: {
        xs: 16,
        md: 24,
    },
    left: {
        xs: 16,
        md: 24,
    },
    zIndex: 1000,
};

export const backButton: SxProps<Theme> = (theme: Theme) => ({
    color: theme.palette.common.white,
    backgroundColor: theme.palette.common.black,
    "&:hover": {
        backgroundColor: "#1c1c1c",
    },
});

export const logoContainer: SxProps<Theme> = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    pt: { xs: 3, sm: 4, md: 5.5 },
    px: { xs: 3, sm: 5, md: 7.5 },
};

export const logoImage: SxProps<Theme> = {
    maxWidth: {
        xs: "300px",
        sm: "450px",
        md: "600px",
    },
    width: "100%",
    height: "auto",
    objectFit: "contain",
};

export const headlineContainer: SxProps<Theme> = {
    fontFamily: "HsvSlab",
    fontSize: {
        xs: "1.5rem",
        sm: "1.875rem",
        md: "2.25rem",
    },
    lineHeight: 1.4,
    textAlign: "center",
    maxWidth: "900px",
    m: "0 auto",
    px: { xs: 3, sm: 5, md: 7.5 },
    pt: { xs: 4, sm: 5, md: 6 },
    color: "#fff",
    letterSpacing: "0.01em",
};

export const headlineFirstLine: SxProps<Theme> = {
    fontFamily: "inherit",
    fontSize: "inherit",
    fontWeight: "600",
    color: "inherit",
    letterSpacing: "inherit",
    lineHeight: "inherit",
    mb: 1,
};

export const headlineSecondLine: SxProps<Theme> = {
    fontFamily: "inherit",
    fontSize: "inherit",
    fontWeight: "500",
    color: "inherit",
    letterSpacing: "inherit",
    lineHeight: "inherit",
};

export const headlineNumber: SxProps<Theme> = {
    color: "#B4A36E",
    fontWeight: "900",
};
